import React from 'react';

import { setHasGuestEmailError } from '@actions/yoga-sauna';
import { Button } from '@components/shared/button';
import GuestInfoModal from '@components/yoga-sauna/guest-info-modal';
import { useYogaSaunaDispatch, useYogaSaunaState } from '@context/yoga-sauna';

type ListBookButton = {
  bookForMe: () => void;
  bookForGuest: (val: { email: string }) => void;
  CTAText: string;
  testId: string;
  disabled: boolean;
  variant?: 'gradient' | 'outline';
  autoWidth?: boolean;
  secondaryText?: string;
};

const ListBookButton: React.FunctionComponent<ListBookButton> = ({
  bookForMe,
  bookForGuest,
  CTAText,
  testId,
  disabled,
  variant = 'gradient',
  // autoWidth,
  secondaryText = '',
}) => {
  const [showGuestModal, setShowGuestModal] = React.useState(false);
  const { isGuestBooking } = useYogaSaunaState();
  const yogaSaunaDispatch = useYogaSaunaDispatch();

  const handleClick = () => {
    if (isGuestBooking) {
      setShowGuestModal(true);
    } else {
      bookForMe();
    }
  };

  const closeModel = () => {
    setShowGuestModal(false);
    yogaSaunaDispatch(setHasGuestEmailError(false));
  };

  return (
    <>
      <Button
        data-testid={testId}
        variant={variant}
        type="button"
        onClick={handleClick}
        disabled={disabled}
        style={{
          lineHeight: '15px',
          letterSpacing: '1.5px',
        }}
      >
        {CTAText}{' '}
        {secondaryText && (
          <span
            style={{
              fontSize: '14px',
              letterSpacing: '0.22px',
              textTransform: 'lowercase',
              position: 'relative',
              top: '4px',
            }}
          >
            {secondaryText}
          </span>
        )}
      </Button>
      {showGuestModal && (
        <GuestInfoModal
          bookForGuest={bookForGuest}
          closeModal={() => closeModel()}
        />
      )}
    </>
  );
};

export default ListBookButton;
